module.exports = __webpack_public_path__ + "static/media/001-braces.8882b0b2.svg";